import { createChatBotMessage } from '../Utils/messageUtils'
import { MessageStrategy } from './messageStrategy'

export class BotMessageStrategy extends MessageStrategy {
  send(message, sendMessage) {
    const botMessage = createChatBotMessage(message)
    sendMessage(botMessage)
  }
}